import { BreakpointObserver } from '@angular/cdk/layout';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { DateAdapter, NativeDateAdapter } from '@angular/material/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CalendarEvent, CalendarEventAction } from 'angular-calendar';
import { isSameDay, isSameMonth } from 'date-fns';
import * as moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import { SkillztankCalendarEvent } from 'src/app/shared/models/event.model';
import { AppConfirmService } from 'src/app/shared/services/app-confirm/app-confirm.service';
import { GroupsService } from '../../groups/groups.service';
import { TodosService } from '../todos/todos.service';
import { AppCalendarService } from './app-calendar.service';
import { CalendarFormDialogComponent } from './calendar-form-dialog/calendar-form-dialog.component';

@Component({
  selector: 'app-calendar',
  templateUrl: './app-calendar.component.html',
  styleUrls: ['./app-calendar.component.scss'],
  standalone: false,
})
export class AppCalendarComponent implements OnInit, OnDestroy {
  public view = 'month';
  public viewDate = new Date();
  private dialogRef: MatDialogRef<CalendarFormDialogComponent>;
  public activeDayIsOpen = false;
  public refresh: Subject<any> = new Subject();
  public events: SkillztankCalendarEvent[] = [];
  private actions: CalendarEventAction[];
  public locale = localStorage.getItem('language') || 'fr';
  public userData = JSON.parse(localStorage.getItem('userData') || '{}');
  public userGroups = JSON.parse(localStorage.getItem('userGroups') || '[]');
  public todoData = { todo: undefined, inProgress: undefined, done: undefined };
  public groupList = [];
  public allEvents = [];
  selectedGroup = 'None';
  todoConfigSubscription: Subscription;
  todoChangeEventSubscription: Subscription;
  /*  @ViewChild('previousButton', {static: false}) previousButtonElement: ElementRef;
   @ViewChild('todayButton', {static: false}) todayButtonElement: ElementRef;
   @ViewChild('nextButton', {static: false}) nextButtonElement: ElementRef;
  */
  colors = {
    todo: '#dfe1e6',
    inProgress: '#172b4d',
    done: '#00875a',
  };
  allTheTodos = [];
  allTheInProgress = [];
  allTheDone = [];

  calendarEventSubscription: Subscription;
  constructor(
    private dateAdapter: DateAdapter<NativeDateAdapter>,
    public dialog: MatDialog,
    public bottomSheet: MatBottomSheet,
    private calendarService: AppCalendarService,
    private confirmService: AppConfirmService,
    private breakpointObserver: BreakpointObserver,
    private translate: TranslateService,
    // private socketService: SocketsService,
    private todosService: TodosService,
    private groupService: GroupsService
  ) {
    this.todoChangeEventSubscription = this.todosService.todoChangeEvent$.subscribe((res) => {
      const date = this.viewDate;
      this.todosService.getTodos(moment(date).utc().format('YYYY-MM-DD'), moment(date).utc().add(1, 'days').format('YYYY-MM-DD')).subscribe((res) => {
        this.sortTodos(res);
      });
    });

    this.todoConfigSubscription = this.todosService.todoDataConfigEvent$.subscribe((res) => {
      switch (res.event) {
        case 'load-todos':
          this.todosService.getTodos(moment(this.viewDate).utc().format('YYYY-MM-DD'), moment(this.viewDate).utc().add(1, 'days').format('YYYY-MM-DD')).subscribe((res) => {
            this.sortTodos(res);
          });
          this.loadEvents();
          break;
      }
    });
    this.dateAdapter.setLocale;
    // this.actions = [{
    //   label: '<i class="material-icons icon-sm">edit</i>',
    //   onClick: ({ event }: { event: CalendarEvent }): void => {
    //     this.handleEvent('edit', event);
    //   }
    // }, {
    //   label: '<i class="material-icons icon-sm">close</i>',
    //   onClick: ({ event }: { event: CalendarEvent }): void => {
    //     this.removeEvent(event);
    //   }
    // }];
    this.calendarEventSubscription = this.calendarService.calendarEvents$.subscribe((res) => {
      switch (res.event) {
        case 'refresh':
          this.loadEvents();
          break;
        case 'view-change':
          this.view = res.data;
          this.loadEvents();
          this.communicateVariablesToDialog();
          break;
        case 'group-selected':
          this.selectedGroup = res.data;
          this.groupSelected();
          this.communicateVariablesToDialog();
          break;
        case 'previous':
          document.getElementById('previousButton').click();
          this.loadEvents();
          this.communicateVariablesToDialog();
          break;
        case 'today':
          document.getElementById('todayButton').click();
          this.loadEvents();
          this.communicateVariablesToDialog();
          break;
        case 'next':
          document.getElementById('nextButton').click();
          this.loadEvents();
          this.communicateVariablesToDialog();
          break;
        case 'request-calendar-value':
          this.communicateVariablesToDialog();
          break;
      }
    });
  }

  ngOnInit() {
    this.loadEvents();
    this.translate.onLangChange.subscribe((event) => {
      this.locale = event.lang;
    });
    // this.getUserGroups();
  }

  ngOnDestroy() {
    this.calendarEventSubscription.unsubscribe();
    this.todoConfigSubscription.unsubscribe();
    this.todoChangeEventSubscription.unsubscribe();
  }

  communicateVariablesToDialog() {
    this.calendarService.sendCalendarEvent({
      event: 'calendar-variables',
      data: {
        view: this.view,
        viewDate: this.viewDate,
        locale: this.locale,
      },
    });
  }

  groupSelected() {
    const filterBySelectedGroup = (todo) => todo.users.findIndex((user) => user.id == this.selectedGroup) != -1;

    if (this.selectedGroup == 'None') {
      this.events = this.allEvents;
      this.todoData.todo = this.allTheTodos;
      this.todoData.inProgress = this.allTheInProgress;
      this.todoData.done = this.allTheDone;
    } else {
      this.todoData.todo = this.allTheTodos.filter(filterBySelectedGroup);
      this.todoData.inProgress = this.allTheInProgress.filter(filterBySelectedGroup);
      this.todoData.done = this.allTheDone.filter(filterBySelectedGroup);
      this.events = this.allEvents.filter((event) => {
        return event.meta['users'].find((user) => {
          return user.id == this.selectedGroup;
        });
      });
    }
  }

  public getUserGroups() {
    this.groupService.getUserGroups().subscribe((res) => {
      const first = { _id: 'None', name: 'Aucun' };
      this.groupList = [first];
      this.groupList = this.groupList.concat(res || []);
    });
  }

  private initEvents(events): SkillztankCalendarEvent[] {
    // let userid = this.userData.id;
    return events.map((event) => {
      event.title = event.name;
      // event.actions = this.actions;
      event.meta = { users: event.users };
      const egretEvent = new SkillztankCalendarEvent(event);
      egretEvent.meta['selectedFreq'] = event.frequency;
      egretEvent.meta['users'] = event.users || [];
      egretEvent.meta.notes = event.notes;
      // egretEvent.color.primary = this.colors[event.TODO.status];
      return egretEvent;
    });
  }

  public loadEvents() {
    let date = moment(this.viewDate || new Date());
    date = moment(date);
    let startDate;
    let endDate;

    if (this.view == 'week') {
      startDate = date.day(0).toDate();
      endDate = date.day(0).add(1, 'w').toDate();
    } else if (this.view == 'day') {
      startDate = date.toDate();
      endDate = date.add(1, 'd').toDate();
    } else {
      startDate = new Date(date.toDate().getFullYear(), date.toDate().getMonth(), 1);
      endDate = new Date(date.toDate().getFullYear(), date.toDate().getMonth() + 1, 1);
    }
    this.calendarService.getRecentEvents(moment(startDate).utc().format(), moment(endDate).utc().format()).subscribe((events) => {
      this.allEvents = this.initEvents(events);
      this.events = this.allEvents;
      this.groupSelected();
    });
  }

  public removeEvent(event) {
    this.confirmService
      .confirm({
        title: this.translate.instant('Calendar.Confrim.DeleteEvent'),
      })
      .subscribe((res) => {
        if (!res) {
          return;
        }
        this.calendarService.deleteEvent(event._id).subscribe((events) => {
          this.loadEvents();
          //     this.socketService.emitEvent('todo-event', {info:'deleted-todo'});
        });
      });
  }

  public removeAllOccurrencesOfEvent(event) {
    this.confirmService
      .confirm({
        title: this.translate.instant('Calendar.Confrim.DeleteAllOccurrecneOfEvent'),
      })
      .subscribe((res) => {
        if (!res) {
          return;
        }
        this.calendarService.deleteAllOccurrenceOfEvent(event._id).subscribe((events) => {
          this.loadEvents();
          //     this.socketService.emitEvent('todo-event', {info:'deleted-todo'});
        });
      });
  }

  public handleEvent(action: string, event: SkillztankCalendarEvent): void {
    const isSmallScreen = this.breakpointObserver.isMatched('(max-width: 599px)');
    let container;
    if (isSmallScreen) {
      container = this.bottomSheet;
    } else {
      container = this.dialog;
    }

    const ref = container.open(CalendarFormDialogComponent, {
      panelClass: 'calendar-form-dialog',
      data: { event, action, contentID: event.contentID },
      // width: '70%'
      minWidth: '500px',
      maxWidth: '60vw',
      maxHeight: '80vh',
    });
    const onCloseSub = ref.afterClosed ? ref.afterClosed() : ref.afterDismissed();
    onCloseSub.subscribe((res) => {
      if (!res) {
        return;
      }
      const dialogAction = res.action;
      const responseEvent = res.event;
      if (dialogAction === 'save') {
        this.calendarService.updateEvent(responseEvent).subscribe((events) => {
          this.loadEvents();
        });
      } else if (dialogAction === 'delete') {
        this.removeEvent(event);
      } else if (dialogAction == 'delete-all-occurrences') {
        this.removeAllOccurrencesOfEvent(event);
      }
    });
  }

  public sortTodos(list) {
    this.todoData.todo = [];
    this.todoData.inProgress = [];
    this.todoData.done = [];
    const userid = this.userData.id;
    for (const element of list) {
      let todoElement = element.statuses.find((e) => e.id == userid);
      if (!todoElement) {
        todoElement = { id: userid, status: 'todo' };
      }
      if (todoElement.status == 'todo') {
        this.todoData.todo.push(element);
      } else if (todoElement.status == 'inProgress') {
        this.todoData.inProgress.push(element);
      } else if (todoElement.status == 'done') {
        this.todoData.done.push(element);
      }
    }
    const nameToTitle = (element) => {
      element.title = element.name;
      return element;
    };

    this.todoData.todo = this.todoData.todo.map(nameToTitle);
    this.todoData.inProgress = this.todoData.inProgress.map(nameToTitle);
    this.todoData.done = this.todoData.done.map(nameToTitle);

    this.allTheTodos = this.todoData.todo;
    this.allTheInProgress = this.todoData.inProgress;
    this.allTheDone = this.todoData.done;
    this.groupSelected();
  }

  public dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
        this.activeDayIsOpen = false;
        this.todoData.todo = [];
        this.todoData.inProgress = [];
        this.todoData.done = [];
      } else {
        this.activeDayIsOpen = true;
        this.viewDate = date;

        this.todosService.getTodos(moment(date).utc().format(), moment(date).utc().add(1, 'days').format()).subscribe((res) => {
          this.sortTodos(res);
        });
      }
    }
  }

  onEditEvent() {
    this.loadEvents();
    this.todosService.getTodos(moment(this.viewDate).utc().format('YYYY-MM-DD'), moment(this.viewDate).utc().add(1, 'days').format('YYYY-MM-DD')).subscribe((res) => {
      this.sortTodos(res);
    });
  }
  public eventTimesChanged({ event, newStart, newEnd }): void {
    event.start = moment(newStart).utc().format();
    event.end = moment(newEnd).utc().format();
    event.startTime = moment(newStart).utc().format('HH:mm');
    event.endTime = moment(newEnd).utc().format('HH:mm');

    this.calendarService.updateEvent({ ...event, name: event.title }).subscribe((events) => {
      this.refresh.next(null);
      this.loadEvents();
    });
  }
}
